import useDealStore from '../store/dealStore'
import { CATEGORY_LABELS, MODULE_NAMES, SEVERITY_CONFIG } from '../data/workflowEngine'
import '../styles/workflow-alerts.css'

function WorkflowAlertsPanel({
  title = 'Workflow & Alerts',
  moduleNumber,
  compact = false,
  limit,
}) {
  const {
    getNotifications,
    markNotificationRead,
    markAllNotificationsRead,
    dismissNotification,
    snoozeNotification,
    navigateToModule,
  } = useDealStore()

  const allAlerts = getNotifications()
  const filteredAlerts = moduleNumber
    ? allAlerts.filter(alert => alert.moduleNumber === moduleNumber)
    : allAlerts
  const alerts = limit ? filteredAlerts.slice(0, limit) : filteredAlerts
  const unreadCount = filteredAlerts.filter(alert => !alert.read).length

  const handleAction = (alert) => {
    markNotificationRead(alert.id)
    navigateToModule(alert.moduleNumber)
  }

  return (
    <section className={`workflow-alert-panel ${compact ? 'compact' : ''}`}>
      <div className="workflow-alert-head">
        <div>
          <h2>{title}</h2>
          <p>{filteredAlerts.length} active item{filteredAlerts.length === 1 ? '' : 's'} across the acquisition workflow</p>
        </div>
        {unreadCount > 0 && (
          <button
            className="workflow-alert-secondary"
            onClick={markAllNotificationsRead}
          >
            Mark All Read ({unreadCount})
          </button>
        )}
      </div>

      {alerts.length === 0 ? (
        <div className="workflow-alert-empty">
          <strong>No active alerts</strong>
          <span>The current workflow has no blocked or overdue actions.</span>
        </div>
      ) : (
        <div className="workflow-alert-list">
          {alerts.map(alert => {
            const config = SEVERITY_CONFIG[alert.severity] || SEVERITY_CONFIG.info
            return (
              <article
                key={alert.id}
                className={`workflow-alert-card ${alert.severity} ${alert.read ? 'read' : 'unread'}`}
                style={{ '--alert-color': config.color, '--alert-bg': config.bg, '--alert-border': config.border }}
              >
                <div className="workflow-alert-icon" aria-hidden="true">🔔</div>
                <div className="workflow-alert-body">
                  <div className="workflow-alert-meta">
                    <span>{MODULE_NAMES[alert.moduleNumber] || `Module ${alert.moduleNumber}`}</span>
                    <span>{CATEGORY_LABELS[alert.category] || alert.category}</span>
                    <span>{config.label}</span>
                  </div>
                  <h3>{alert.title}</h3>
                  <p>{alert.message}</p>
                  <div className="workflow-alert-actions">
                    <button onClick={() => handleAction(alert)}>{alert.actionText || 'Open Module'}</button>
                    {!alert.read && (
                      <button className="ghost" onClick={() => markNotificationRead(alert.id)}>✓ Mark as Read</button>
                    )}
                    <button className="ghost" onClick={() => snoozeNotification(alert.id, 120)}>Snooze</button>
                    {alert.dismissible !== false && (
                      <button className="ghost" onClick={() => dismissNotification(alert.id)}>Dismiss</button>
                    )}
                  </div>
                </div>
              </article>
            )
          })}
        </div>
      )}
    </section>
  )
}

export default WorkflowAlertsPanel
